module.exports = __webpack_public_path__ + "img/5656242.jpg";